import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';
import { useLang } from '../context/LangContext';
import { useAuth } from '../context/AuthContext';
import Header from '../components/Header';
import Footer from '../components/Footer';

const API = process.env.REACT_APP_API_URL || '';

export default function Pricing() {
  const { t, dir } = useLang();
  const { isAuthenticated, isPro, token } = useAuth();
  const navigate = useNavigate();
  const P = t.pricing;
  const [loading, setLoading] = useState(false);

  const handleProCta = async () => {
    if (!isAuthenticated) { navigate('/register'); return; }
    if (isPro) { navigate('/app'); return; }
    setLoading(true);
    try {
      const { data } = await axios.post(
        `${API}/api/payments/checkout`, {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      window.location.href = data.checkout_url;
    } catch (err) {
      toast.error(err.response?.data?.detail || t.errors.serverError);
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--primary)' }}>
      <Header />
      <main style={{ maxWidth: '900px', margin: '0 auto', padding: '60px 24px', direction: dir }}>

        <div style={{ textAlign: 'center', marginBottom: '56px' }}>
          <h1 style={{ fontSize: '36px', fontWeight: 800, color: '#f0f0f5', marginBottom: '12px' }}>{P.title}</h1>
          <p style={{ color: '#9ca3af', fontSize: '17px' }}>{P.subtitle}</p>
        </div>

        {/* Plans */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '24px', marginBottom: '64px' }}>
          {/* Free */}
          <PlanCard plan={P.free} color="#00d4aa">
            <Link to="/register" style={ctaStyle('#00d4aa', false)}>{P.free.cta}</Link>
          </PlanCard>

          {/* Pro */}
          <PlanCard plan={P.pro} color="#f0a500" highlighted>
            <button
              onClick={handleProCta}
              disabled={loading}
              style={ctaStyle('#f0a500', true)}
            >
              {loading ? <><span className="spinner" /> ...</> : P.pro.cta}
            </button>
          </PlanCard>
        </div>

        {/* FAQ */}
        <div>
          <h2 style={{ fontSize: '24px', fontWeight: 800, color: '#f0f0f5', marginBottom: '28px', textAlign: 'center' }}>FAQ</h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {P.faq.map((item, i) => (
              <div key={i} style={{
                background: 'var(--surface)',
                border: '1px solid var(--border)',
                borderRadius: '12px',
                padding: '20px 24px',
              }}>
                <p style={{ fontWeight: 700, color: '#f0f0f5', marginBottom: '8px' }}>{item.q}</p>
                <p style={{ color: '#9ca3af', fontSize: '14px', lineHeight: 1.7 }}>{item.a}</p>
              </div>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

function PlanCard({ plan, color, children, highlighted }) {
  return (
    <div style={{
      background: highlighted ? `linear-gradient(135deg, ${color}18, var(--surface))` : 'var(--surface)',
      border: `2px solid ${highlighted ? color : 'var(--border)'}`,
      borderRadius: '20px',
      padding: '36px',
      position: 'relative',
    }}>
      {highlighted && (
        <div style={{
          position: 'absolute', top: -12, left: '50%', transform: 'translateX(-50%)',
          background: color, color: '#0d0d1a', borderRadius: '20px',
          padding: '4px 16px', fontSize: '12px', fontWeight: 700,
        }}>
          ★ Pro
        </div>
      )}
      <div style={{ marginBottom: '8px', color, fontSize: '13px', fontWeight: 700 }}>{plan.name}</div>
      <div style={{ fontSize: '40px', fontWeight: 800, color: '#f0f0f5', marginBottom: '4px' }}>
        {plan.price}<span style={{ fontSize: '16px', color: '#9ca3af' }}>{plan.period || ''}</span>
      </div>
      <div style={{ borderTop: '1px solid var(--border)', margin: '20px 0', paddingTop: '20px' }}>
        {plan.features.map((f, i) => (
          <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '12px', color: '#d1d5db', fontSize: '14px' }}>
            <span style={{ color, fontWeight: 700 }}>✓</span> {f}
          </div>
        ))}
      </div>
      {children}
    </div>
  );
}

function ctaStyle(color, filled) {
  return {
    display: 'block',
    width: '100%',
    padding: '14px',
    background: filled ? `linear-gradient(135deg, ${color}, ${color}cc)` : 'transparent',
    color: filled ? '#0d0d1a' : color,
    border: `2px solid ${color}`,
    borderRadius: '10px',
    fontFamily: 'Tajawal, sans-serif',
    fontSize: '16px',
    fontWeight: 700,
    cursor: 'pointer',
    textDecoration: 'none',
    textAlign: 'center',
    transition: 'all 0.2s',
  };
}
